import { useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import {
  AppCard,
  AppInputNumber,
  AppMultiSelect,
  AppSingleSelect,
} from '@/layout/AppComponents';
import Translator from '../../../components/helpers/Translator';
import _ from 'lodash';

export default function ModuleComsaEnvironmentalRailwayConstruction(props) {
  const {
    values,
    errors,
    setFieldValue,
    noYesOptions,
    affectedServicesOptions,
  } = props;
  const [trackLengthOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="18.meters" />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="36.meters" />
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="144.meters" />
      ),
      value: 2,
    },
  ]);
  const [managementByClientOrComsaOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="management.by.client"
        />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="management.by.comsa"
        />
      ),
      value: 1,
    },
  ]);

  return (
    <AppCard
      header={ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="railway.works" />
      )}
      className="mb-2"
    >
      <h6>
        <Translator
          file="module-comsaEnvironmental"
          name="indicate.length.meters.works.carried.out"
        />
      </h6>
      <AppInputNumber
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="single.track.renewal.indicate.meters"
          />
        )}
        onChange={(value) => setFieldValue('simpleTrackRenewal', value)}
        value={values?.simpleTrackRenewal}
        error={errors?.simpleTrackRenewal}
        isClearable
      />
      <AppInputNumber
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="double.track.renewal.indicate.meters"
          />
        )}
        onChange={(value) => setFieldValue('doubleTrackRenewal', value)}
        value={values?.doubleTrackRenewal}
        error={errors?.doubleTrackRenewal}
        isClearable
      />
      <AppInputNumber
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="new.track.indicate.meters"
          />
        )}
        onChange={(value) => setFieldValue('newTrack', value)}
        value={values?.newTrack}
        error={errors?.newTrack}
        isClearable
      />
      <AppInputNumber
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="track.dismantling.indicate.meters"
          />
        )}
        onChange={(value) => setFieldValue('stripped', value)}
        value={values?.stripped}
        error={errors?.stripped}
        isClearable
      />
      <AppInputNumber
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="track.tamping.indicate.meters"
          />
        )}
        onChange={(value) => setFieldValue('trackHit', value)}
        value={values?.trackHit}
        error={errors?.trackHit}
        isClearable
      />
      <AppSingleSelect
        options={trackLengthOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="indicate.length.rail.used"
          />
        )}
        value={values?.trackLength}
        error={errors?.trackLength}
        onChange={(opt) => setFieldValue('trackLength', opt)}
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="execution.welding.contemplated.project"
          />
        )}
        value={values?.solderingExecution}
        error={errors?.solderingExecution}
        onChange={(opt) => setFieldValue('solderingExecution', opt)}
        isClearable
      />
      <AppInputNumber
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="indicate.dismantling.depth.applicable.indicate.centimeters"
          />
        )}
        onChange={(value) => setFieldValue('strippedDepth', value)}
        value={values?.strippedDepth}
        error={errors?.strippedDepth}
        isClearable
      />
      <h6>
        <Translator
          file="module-comsaEnvironmental"
          name="indicate.each.type.waste.management.carried.client.comsa"
        />
      </h6>
      <AppSingleSelect
        options={managementByClientOrComsaOptions}
        title={ReactDOMServer.renderToString(
          <Translator file="module-comsaEnvironmental" name="ballast" />
        )}
        value={values?.ballast}
        error={errors?.ballast}
        onChange={(opt) => setFieldValue('ballast', opt)}
        isClearable
      />
      {values?.ballast === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.quantity.tonnes"
              />
            )}
            onChange={(value) => setFieldValue('ballastQuantity', value)}
            value={values?.ballastQuantity}
            error={errors?.ballastQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={managementByClientOrComsaOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="concrete.sleepers"
          />
        )}
        value={values?.concreteRailroad}
        error={errors?.concreteRailroad}
        onChange={(opt) => setFieldValue('concreteRailroad', opt)}
        isClearable
      />
      {values?.concreteRailroad === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.quantity.tonnes"
              />
            )}
            onChange={(value) =>
              setFieldValue('concreteRailroadQuantity', value)
            }
            value={values?.concreteRailroadQuantity}
            error={errors?.concreteRailroadQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={managementByClientOrComsaOptions}
        title={ReactDOMServer.renderToString(
          <Translator file="module-comsaEnvironmental" name="wooden.sleepers" />
        )}
        value={values?.woodRailroad}
        error={errors?.woodRailroad}
        onChange={(opt) => setFieldValue('woodRailroad', opt)}
        isClearable
      />
      {values?.woodRailroad === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.quantity.tonnes"
              />
            )}
            onChange={(value) => setFieldValue('woodRailroadQuantity', value)}
            value={values?.woodRailroadQuantity}
            error={errors?.woodRailroadQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={managementByClientOrComsaOptions}
        title={ReactDOMServer.renderToString(
          <Translator file="module-comsaEnvironmental" name="lane" />
        )}
        value={values?.track}
        error={errors?.track}
        onChange={(opt) => setFieldValue('track', opt)}
        isClearable
      />
      {values?.track === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.quantity.tonnes"
              />
            )}
            onChange={(value) => setFieldValue('trackQuantity', value)}
            value={values?.trackQuantity}
            error={errors?.trackQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.stockpile.ballast.yes.indicate.estimated.volume"
          />
        )}
        value={values?.ballastCollection}
        error={errors?.ballastCollection}
        onChange={(opt) => setFieldValue('ballastCollection', opt)}
        isClearable
      />
      {values?.ballastCollection === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('ballastCollectionVolumeM3', value)
            }
            value={values?.ballastCollectionVolumeM3}
            error={errors?.ballastCollectionVolumeM3}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.foreseen.stockpile.sleepers.pairs.worksite.yes.quantity"
          />
        )}
        value={values?.railroadCollection}
        error={errors?.railroadCollection}
        onChange={(opt) => setFieldValue('railroadCollection', opt)}
        isClearable
      />
      {values?.railroadCollection === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.quantity.sleepers.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('railroadCollectionQuantity', value)
            }
            value={values?.railroadCollectionQuantity}
            error={errors?.railroadCollectionQuantity}
            isClearable
          />
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.quantity.pairs.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('railroadCollectionCoupleQuantity', value)
            }
            value={values?.railroadCollectionCoupleQuantity}
            error={errors?.railroadCollectionCoupleQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="knowledge.possible.presence.asbestos.prefabricated.manholes.dismantled"
          />
        )}
        value={values?.asbestos}
        error={errors?.asbestos}
        onChange={(opt) => setFieldValue('asbestos', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="execution.railway.electrification.yes.indicate.length.section.electrified"
          />
        )}
        value={values?.railwayElectrification}
        error={errors?.railwayElectrification}
        onChange={(opt) => setFieldValue('railwayElectrification', opt)}
        isClearable
      />
      {values?.railwayElectrification === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.length.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('railwayElectrificationLength', value)
            }
            value={values?.railwayElectrificationLength}
            error={errors?.railwayElectrificationLength}
            isClearable
          />
        </div>
      )}
      <h6 className="text-center my-4">
        <Translator
          file="module-comsaEnvironmental"
          name="electrification.works"
        />
      </h6>
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="heavy.machinery.foreseen.ferrotrucks.draisines.yes.number.vehicles.vehicle.presence"
          />
        )}
        value={values?.heavyMachinery}
        error={errors?.heavyMachinery}
        onChange={(opt) => setFieldValue('heavyMachinery', opt)}
        isClearable
      />
      {values?.heavyMachinery === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.number.vehicles"
              />
            )}
            onChange={(value) => setFieldValue('heavyMachineryNumber', value)}
            value={values?.heavyMachineryNumber}
            error={errors?.heavyMachineryNumber}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="dismantling.installations.contemplated.yes.section.dismantled"
          />
        )}
        value={values?.plantDismantling}
        error={errors?.plantDismantling}
        onChange={(opt) => setFieldValue('plantDismantling', opt)}
        isClearable
      />
      {values?.plantDismantling === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.length.meters"
              />
            )}
            onChange={(value) => setFieldValue('plantDismantlingLength', value)}
            value={values?.plantDismantlingLength}
            error={errors?.plantDismantlingLength}
            isClearable
          />
        </div>
      )}
      <h6>
        <Translator
          file="module-comsaEnvironmental"
          name="indicate.each.type.waste.management.carried.client.comsa"
        />
      </h6>
      <AppSingleSelect
        options={managementByClientOrComsaOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="posts.brackets.gantries.general.hardware"
          />
        )}
        value={values?.ironWork}
        error={errors?.ironWork}
        onChange={(opt) => setFieldValue('ironWork', opt)}
        isClearable
      />
      {_.isNumber(values?.ironWork) && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.quantity.tonnes"
              />
            )}
            onChange={(value) => setFieldValue('ironWorkQuantity', value)}
            value={values?.ironWorkQuantity}
            error={errors?.ironWorkQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={managementByClientOrComsaOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="contact.wires.supports.feeders"
          />
        )}
        value={values?.feeders}
        error={errors?.feeders}
        onChange={(opt) => setFieldValue('feeders', opt)}
        isClearable
      />
      {_.isNumber(values?.feeders) && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.quantity.tonnes"
              />
            )}
            onChange={(value) => setFieldValue('feedersQuantity', value)}
            value={values?.feedersQuantity}
            error={errors?.feedersQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={managementByClientOrComsaOptions}
        title={ReactDOMServer.renderToString(
          <Translator file="module-comsaEnvironmental" name="insulators" />
        )}
        value={values?.isolators}
        error={errors?.isolators}
        onChange={(opt) => setFieldValue('isolators', opt)}
        isClearable
      />
      {_.isNumber(values?.isolators) && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.quantity.tonnes"
              />
            )}
            onChange={(value) => setFieldValue('isolatorsQuantity', value)}
            value={values?.isolatorsQuantity}
            error={errors?.isolatorsQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="demolition.foundation.massifs.foreseen.affirmative.indicate.volume"
          />
        )}
        value={values?.solidDemolition}
        error={errors?.solidDemolition}
        onChange={(opt) => setFieldValue('solidDemolition', opt)}
        isClearable
      />
      {values?.solidDemolition === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('solidDemolitionQuantity', value)
            }
            value={values?.solidDemolitionQuantity}
            error={errors?.solidDemolitionQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="concrete.foreseen.foundation.massifs.yes.volume"
          />
        )}
        value={values?.useOfConcrete}
        error={errors?.useOfConcrete}
        onChange={(opt) => setFieldValue('useOfConcrete', opt)}
        isClearable
      />
      {values?.useOfConcrete === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) => setFieldValue('useOfConcreteQuantity', value)}
            value={values?.useOfConcreteQuantity}
            error={errors?.useOfConcreteQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="knowledge.prior.existence.industrial.installations.have.contaminated.soil"
          />
        )}
        value={values?.previousPlantsExistence}
        error={errors?.previousPlantsExistence}
        onChange={(opt) => setFieldValue('previousPlantsExistence', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="there.need.install.generators.yes.indicate.quantity"
          />
        )}
        value={values?.generatorNeed}
        error={errors?.generatorNeed}
        onChange={(opt) => setFieldValue('generatorNeed', opt)}
        isClearable
      />
      {values?.generatorNeed === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.number.generators"
              />
            )}
            onChange={(value) => setFieldValue('generatorNeedNumber', value)}
            value={values?.generatorNeedNumber}
            error={errors?.generatorNeedNumber}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="need.included.perform.catenary.maintenance.works"
          />
        )}
        value={values?.maintenanceWorkNeed}
        error={errors?.maintenanceWorkNeed}
        onChange={(opt) => setFieldValue('maintenanceWorkNeed', opt)}
        isClearable
      />
      <h6 className="text-center my-4">
        <Translator file="module-comsaEnvironmental" name="common.aspects" />
      </h6>
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="traffic.disruptions.foreseen.beyond.framework.plan"
          />
        )}
        value={values?.railwayTrafficVariation}
        error={errors?.railwayTrafficVariation}
        onChange={(opt) => setFieldValue('railwayTrafficVariation', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="tunnel.consolidation.expected.gunita.yes.indicate.estimated.volume.gunita"
          />
        )}
        value={values?.tunnelStrengthening}
        error={errors?.tunnelStrengthening}
        onChange={(opt) => setFieldValue('tunnelStrengthening', opt)}
        isClearable
      />
      {values?.tunnelStrengthening === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.volume.cubic.meters"
              />
            )}
            onChange={(value) =>
              setFieldValue('tunnelStrengtheningQuantity', value)
            }
            value={values?.tunnelStrengtheningQuantity}
            error={errors?.tunnelStrengtheningQuantity}
            isClearable
          />
        </div>
      )}
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="project.contemplate.execution.works.night"
          />
        )}
        value={values?.nightWork}
        error={errors?.nightWork}
        onChange={(opt) => setFieldValue('nightWork', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="opening.roads.access.tracks.necessary.yes.new.roads.tracks"
          />
        )}
        value={values?.pathOpening}
        error={errors?.pathOpening}
        onChange={(opt) => setFieldValue('pathOpening', opt)}
        isClearable
      />
      {values?.pathOpening === 1 && (
        <div className="pl-4">
          <AppInputNumber
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="indicate.length.meters"
              />
            )}
            onChange={(value) => setFieldValue('pathOpeningQuantity', value)}
            value={values?.pathOpeningQuantity}
            error={errors?.pathOpeningQuantity}
            isClearable
          />
        </div>
      )}
      <AppInputNumber
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="indicate.number.people.involved.project.during.peak.periods"
          />
        )}
        onChange={(value) => setFieldValue('personNumber', value)}
        value={values?.personNumber}
        error={errors?.personNumber}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="clearing.pruning.bushes.trees.expected"
          />
        )}
        value={values?.treeClear}
        error={errors?.treeClear}
        onChange={(opt) => setFieldValue('treeClear', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="expected.increase.employment.construction.works.socioeconomic.impact.study"
          />
        )}
        value={values?.employmentIncrease}
        error={errors?.employmentIncrease}
        onChange={(opt) => setFieldValue('employmentIncrease', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="expected.increase.economic.activity.area.execution.construction.socioeconomic.impact.study"
          />
        )}
        value={values?.economicActivityIncrease}
        error={errors?.economicActivityIncrease}
        onChange={(opt) => setFieldValue('economicActivityIncrease', opt)}
        isClearable
      />
      <AppSingleSelect
        options={noYesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="expected.decrease.economic.activity.area.execution.construction.socioeconomic.impact.study"
          />
        )}
        value={values?.economicActivityDecrease}
        error={errors?.economicActivityDecrease}
        onChange={(opt) => setFieldValue('economicActivityDecrease', opt)}
        isClearable
      />
      <AppMultiSelect
        options={affectedServicesOptions}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-comsaEnvironmental"
            name="affected.services.work.area.yes.select.type.affected.services"
          />
        )}
        value={values?.affectedServices || []}
        error={errors?.affectedServices}
        onChange={(opt) => setFieldValue('affectedServices', opt)}
        hasSelectOptions
      />
    </AppCard>
  );
}
